import React from 'react';
import InstructionsContents from './InstructionsContent';

export interface InstructionsProps {
  instructionTitle: string;
  examType: string;
  examTitle: string;
  path: string;
}

const Instructions = ({ instructionTitle, examType, examTitle, path }: InstructionsProps) => (
  <InstructionsContents
    instructionTitle={instructionTitle}
    examType={examType}
    examTitle={examTitle}
    path={path}
  />
);

export default Instructions;
